import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { DEFAULT_SOLO_BRACKET, normalizeBracket } from "./content-brackets";
export function useBracketParam(t0) {
  const $ = _c(11);
  const fallback = t0 === undefined ? DEFAULT_SOLO_BRACKET : t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== fallback || $[1] !== searchParams) {
    const raw = searchParams.get("bracket");
    t1 = raw ? normalizeBracket(raw) : fallback;
    $[0] = fallback;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const bracket = t1;
  let t2;
  if ($[3] !== fallback || $[4] !== pathname || $[5] !== router || $[6] !== searchParams) {
    t2 = b => {
      const p = new URLSearchParams(searchParams.toString());
      if (b === fallback) {
        p.delete("bracket");
      } else {
        p.set("bracket", b);
      }
      const qs = p.toString();
      router.replace(`${pathname}${qs ? `?${qs}` : ""}`, {
        scroll: false
      });
    };
    $[3] = fallback;
    $[4] = pathname;
    $[5] = router;
    $[6] = searchParams;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const setBracket = t2;
  let t3;
  if ($[8] !== bracket || $[9] !== setBracket) {
    t3 = [bracket, setBracket];
    $[8] = bracket;
    $[9] = setBracket;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3 as const;
}